export const manageTeamMembersActionTypes = {
  GET_MEMBERS: 'teams/GET_MEMBERS',
  GET_MEMBERS_PENDING: 'teams/GET_MEMBERS_PENDING',
  GET_MEMBERS_SUCCESS: 'teams/GET_MEMBERS_SUCCESS',
  GET_MEMBERS_FAILED: 'teams/GET_MEMBERS_FAILED',
  GET_MEMBERS_CLEANUP: 'teams/GET_MEMBERS_CLEANUP',

  UPDATE_EMPLOYEE_DETAILS: 'teams/UPDATE_EMPLOYEE_DETAILS',
  UPDATE_EMPLOYEE_DETAILS_PENDING: 'teams/UPDATE_EMPLOYEE_DETAILS_PENDING',
  UPDATE_EMPLOYEE_DETAILS_SUCCESS: 'teams/UPDATE_EMPLOYEE_DETAILS_SUCCESS',
  UPDATE_EMPLOYEE_DETAILS_FAILED: 'teams/UPDATE_EMPLOYEE_DETAILS_FAILED',
  UPDATE_EMPLOYEE_DETAILS_CLEANUP: 'teams/UPDATE_EMPLOYEE_DETAILS_CLEANUP',

  REMOVE_USER_FROM_TEAM: 'teams/REMOVE_USER_FROM_TEAM',
  REMOVE_USER_FROM_TEAM_PENDING: 'teams/REMOVE_USER_FROM_TEAM_PENDING',
  REMOVE_USER_FROM_TEAM_SUCCESS: 'teams/REMOVE_USER_FROM_TEAM_SUCCESS',
  REMOVE_USER_FROM_TEAM_FAILED: 'teams/REMOVE_USER_FROM_TEAM_FAILED',
  REMOVE_USER_FROM_TEAM_CLEANUP: 'teams/REMOVE_USER_FROM_TEAM_CLEANUP',
};
export const manageTeamsActionTypes = {
  GET_TEAMS: 'teams/GET_TEAMS',
  GET_TEAMS_PENDING: 'teams/GET_TEAMS_PENDING',
  GET_TEAMS_SUCCESS: 'teams/GET_TEAMS_SUCCESS',
  GET_TEAMS_FAILED: 'teams/GET_TEAMS_FAILED',
  GET_TEAMS_CLEANUP: 'teams/GET_TEAMS_CLEANUP',
};
